var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AdminTable',{ref:"table",attrs:{"columns":_vm.columns,"title":`Коллекция items-counters`,"model-name":"itemsCounterModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }